/**
 * Whether the "I am on site" checkbox targets the ordering user rather than the client an admin orders for. One
 * rule for the checkbox and for `on_site_contact_is_orderer` on the instructions step's next click (ISSUE-4023).
 * Unknown e-mails (user data still loading) never count as the orderer. The addresses come from the same
 * backend-normalised source, so a plain comparison is the rule.
 */
export const isOrdererTheContactPerson = (targetUserEmail: string | undefined, orderingUserEmail: string | undefined): boolean =>
  !!targetUserEmail && targetUserEmail === orderingUserEmail
